import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineConnectedPlatformDeploymentAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  if ([AuthAuthPermissions.SYSTEM_MANAGEMENT, AuthAuthPermissions.INFERENCE].every(p => permissions.includes(p))) {
    can('crud', 'ConnectedPlatformDeployment')
  }
}
